const actionTransformerMiddleware = () => next => action => {
  const transformedAction = {
    ...action
  };
  return next(transformedAction);
};

export default actionTransformerMiddleware;
